/* PHN cart helper (17 Sep 2026). Loaded from layout/theme.liquid after theme.js.
   Configurator lines (hidden _phn_chars property) have no quantity stepper in the
   cart, and Impulse hides its own Remove link inside the cart drawer, so those
   lines could not be removed from the drawer. snippets/cart-item.liquid gives
   them a Remove link marked data-phn-remove; this removes the line in place
   through the theme's own cart code and rebuilds the drawer or cart page. If the
   theme's cart object is missing the link falls through to its href. */
(function () {
  'use strict';
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('[data-phn-remove]');
    if (!a) return;
    if (!(window.theme && theme.cart && theme.cart.changeItem)) return;
    e.preventDefault();
    if (a.dataset.phnBusy) return;
    a.dataset.phnBusy = '1';
    var key = a.dataset.phnRemove, item = a.closest('.cart__item');
    if (item) item.style.opacity = '.4';
    theme.cart.changeItem(key, 0).then(function (cart) {
      var parsed = typeof cart === 'string' ? JSON.parse(cart) : cart;
      document.dispatchEvent(new CustomEvent('cart:build'));
      document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: parsed } }));
    }).catch(function () { window.location.href = a.href; });
  });
})();
